import { render, staticRenderFns } from "./FoodSupplement.vue?vue&type=template&id=a2937a0c&scoped=true&"
import script from "./FoodSupplement.vue?vue&type=script&lang=js&"
export * from "./FoodSupplement.vue?vue&type=script&lang=js&"
import style0 from "./FoodSupplement.vue?vue&type=style&index=0&id=a2937a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2937a0c",
  null
  
)

export default component.exports